'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _MyPlaylistTrack = require('containers/MyPlaylist/components/MyPlaylistTrack');

var _MyPlaylistTrack2 = _interopRequireDefault(_MyPlaylistTrack);

var _List = require('components/List/List');

var _List2 = _interopRequireDefault(_List);

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _NoAudio = require('./NoAudio');

var _NoAudio2 = _interopRequireDefault(_NoAudio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./MyPlaylistTracks.scss');

var MyPlaylistTracks = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(MyPlaylistTracks, _Component);

  function MyPlaylistTracks() {
    (0, _classCallCheck3.default)(this, MyPlaylistTracks);
    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistTracks.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistTracks)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyPlaylistTracks, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          tracks = _props.tracks,
          playlist = _props.playlist,
          loading = _props.loading;

      var isNoTracks = !loading && !tracks.length;

      return _react2.default.createElement(
        'div',
        null,
        !isNoTracks && _react2.default.createElement(
          _List2.default,
          { className: (0, _bind2.default)(styles.tracks) },
          tracks.map(function (track, trackIndex) {
            return _react2.default.createElement(_MyPlaylistTrack2.default, {
              key: track.id,
              playlist: playlist,
              track: track,
              trackIndex: trackIndex,
              playlistTracks: tracks
            });
          })
        ),
        isNoTracks && _react2.default.createElement(_NoAudio2.default, null),
        _react2.default.createElement(_Loader2.default, { alignCenter: true, small: true, show: loading })
      );
    }
  }]);
  return MyPlaylistTracks;
}(_react.Component), _class.propTypes = {
  loading: _propTypes2.default.bool,
  playlist: _propTypes2.default.object,
  tracks: _propTypes2.default.array
}, _class.defaultProps = {
  playlist: { list: [] },
  tracks: []
}, _temp);
exports.default = MyPlaylistTracks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyPlaylist/components/MyPlaylistTracks.js
// module id = 2168
// module chunks = 1